import { Apis } from '../../app.constants.js';
import APIService from '../../APIService.js';

type EntityActionsType = {
  getFormList: (data: any) => Promise<any>;
  getFormById: (id: any) => Promise<any>;
  deleteForm: (id: any) => Promise<any>;
  createForm: (data: any) => Promise<any>;
  updateForm: (id: any, data: any) => Promise<any>;
  getEntityList: (data: any) => Promise<any>;
  createEntity: (data: any) => Promise<any>;
  deleteEntityDetail: (id: any) => Promise<any>;
  updateDetails: (id: any, data: any) => Promise<any>;
  uploadEntityData: (data: any, entity_form_id: any, onUploadProgress: any) => Promise<any>;
  downloadEntitySampleFile: (id: any) => Promise<any>;
  getEntityDataById: (id: any) => Promise<any>;
  getEntityDropdown: (entityFormId: any, returnFields?: any[], queryParams?: any[]) => Promise<any>;
};

const EntityActions = (): EntityActionsType => {
  const createForm = async (data: any): Promise<any> => {
    try {
      const res: any = await APIService.post(`${Apis.entityForm}create`, data);
      if (res?.status === 200) {
        return res;
      } else {
        throw new Error('Failed to delete form. Server responded with an error.');
      }
    } catch (error) {
      throw new Error(error);
    }
  };

  const updateForm = async (id: any, data: any): Promise<any> => {
    try {
      const res: any = await APIService.put(`${Apis.entityForm}update/?id=${id}`, data);
      if (res?.status === 200) {
        return res;
      } else {
        throw new Error('Failed to delete form. Server responded with an error.');
      }
    } catch (error) {
      throw new Error(error);
    }
  };

  const getFormList = async (data: any): Promise<any> => {
    try {
      const parentIdParam = data?.parentEntityFormId ? `&parent_id=${data.parentEntityFormId}` : '';
      const res = await APIService.get(
        `${Apis.entityForm}list?next_page=${data?.page}&limit=${data?.limit}&search=${data?.search || ''}${parentIdParam}`
      );
      if (res?.status === 200) {
        return res;
      } else {
        throw new Error('Failed to fetch form list. Server responded with an error.');
      }
    } catch (error) {
      console.error('Error posting SMS list:', error);
      throw error;
    }
  };
  const deleteForm = async (id: any): Promise<any> => {
    try {
      const res = await APIService.remove(`${Apis.entityForm}delete/?id=${id}`);
      if (res?.status === 200) {
        return res;
      } else {
        return res;
      }
    } catch (error) {
      throw new Error(error);
    }
  };
  const getEntityList = async (data: any): Promise<any> => {
    try {
      const res = await APIService.get(
        `${Apis.entityManagement}get-entity-list/?next_page=${data?.page}&entity_form_id=${data?.entityFormId || ''}&limit=${data?.limit}&search=${data?.search || ''}&parent_id=${data?.parentEntityId ?? ''}`
      );
      if (res?.status === 200) {
        return res;
      } else {
        throw new Error('Failed to fetch entity list. Server responded with an error.');
      }
    } catch (error) {
      throw error;
    }
  };
  const createEntity = async (data: any): Promise<any> => {
    try {
      const res: any = await APIService.post(`${Apis.entityManagement}create`, data);
      if (res?.status === 200) {
        return res;
      } else {
        throw new Error('Failed to create entity. Server responded with an error.');
      }
    } catch (error) {
      throw new Error(error);
    }
  };

  const getFormById = async (id: any): Promise<any> => {
    try {
      const res = await APIService.get(`${Apis.getEntityFormById}/?id=${id}`);
      if (res?.status === 200) {
        return res;
      } else {
        throw new Error('Failed to create entity. Server responded with an error.');
      }
    } catch (error) {
      throw new Error(error);
    }
  };

  const deleteEntityDetail = async (id: any): Promise<any> => {
    try {
      const res = await APIService.remove(`${Apis.entityManagement}entity-delete/?id=${id}`);
      if (res?.status === 200) {
        return res;
      } else {
        throw new Error('Failed to delete Entity Details. Server responded with an error.');
      }
    } catch (error) {
      throw new Error(error);
    }
  };

  const updateDetails = async (id: any, data: any): Promise<any> => {
    try {
      const res: any = await APIService.put(
        `${Apis.entityManagement}entity-update/?id=${id}`,
        data
      );
      if (res?.status === 200) {
        return res;
      } else {
        throw new Error('Failed to update Entity Details. Server responded with an error.');
      }
    } catch (error) {
      throw new Error(error);
    }
  };

  const uploadEntityData = async (data: any, entity_form_id: any, onUploadProgress: any) => {
    try {
      let res: any = await APIService.uploadFile(
        `${Apis.uploadEntityData}?entity_form_id=${entity_form_id}`,
        data,
        onUploadProgress
      );
      if (res?.status === 200) {
        return res;
      } else {
        throw new Error('Failed to update Entity Details. Server responded with an error.');
      }
    } catch (error) {
      throw new Error(error);
    }
  };
  const downloadEntitySampleFile = async (id: any) => {
    try {
      const url = `${Apis.downloadEntitySampleFile}?id=${id}`;
      await APIService.downloadFile(url, `${id}_Entity.xlsx`);
      // window.location.href = `${process.env.REACT_APP_API_URL}${Apis.downloadEntitySampleFile}?id=${id}`;
    } catch (error) {
      throw new Error(error);
    }
  };

  const getEntityDataById = async (id: any): Promise<any> => {
    try {
      const res = await APIService.get(`${Apis.getEntityDataById}?id=${id}`);
      return res;
    } catch (error) {
      throw new Error(error);
    }
  };
  
  return {
    createForm,
    updateForm,
    getFormList,
    deleteForm,
    getEntityList,
    createEntity,
    getFormById,
    deleteEntityDetail,
    updateDetails,
    uploadEntityData,
    downloadEntitySampleFile,
    getEntityDataById,
  };
};

export { EntityActions };
